module.exports = __webpack_public_path__ + "img/362.25dea83e.png";